<template>
    <mdb-modal @close="cancelTransaction" class="animated bounceInLeft" info
               position="top-center" size="lg" v-if="showModal">
      <mdb-modal-header>
        <p class="heading">Add transaction for {{currentGroup.name}}</p>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="md-form">
          <div>
            <datetime :format="userDetails.dateFormat"
                      :valueZone="userDetails.timezone"
                      :auto="true"
                      :weekStart="userDetails.mondayFirst ? 1 : 7" v-model="editingTransaction.date">
              :zone="userDetails.timezone" :format="userDetails.dateFormat">
            </datetime>
            <label class="active mr-5">Date</label>
          </div>
        </div>

        <mdb-input type="text" v-model="editingTransaction.description" placeholder="Transaction description. Optional." label="Description"></mdb-input>
        <mdb-input type="number" :step="0.01" :separator="userDetails.decimalSeparator" minus  v-model="editingTransaction.amount" label="Amount" placeholder="Amount"></mdb-input>
        <div class="md-form">
          <select class="material-input form-control"
                  id="trans-type"
                  v-model="editingTransaction.category">
            <option :value="cat.id" v-for="cat in categories">{{cat.name}}</option>
          </select>
          <label class="active mr-5">Category</label>
        </div>
        <mdb-btn @click="saveTransaction" icon="save"
                 :disabled="!editingTransaction.category|| !editingTransaction.date || !editingTransaction.amount">Save</mdb-btn>
        <mdb-btn @click="cancelTransaction" icon="ban">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {Datetime} from 'vue-datetime'
import {mdbBtn, mdbInput, mdbModal, mdbModalBody, mdbModalFooter, mdbModalHeader,} from 'mdbvue';

export default {
    name: 'Group-Transaction',
    components: {
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbInput,
      Datetime
    },
    props: {
      transaction: {
        type: Object,
        default: null
      },
      categories: {
        type: Array,
        default: null
      }
    },
    mounted() {
      this.editingTransaction = JSON.parse(JSON.stringify(this.transaction))
    },
    computed: {
      currentGroup: function () {
        return this.$store.state.currentGroup
      },
      userDetails: function () {
        return this.$store.state.userDetails
      }
    },
    data() {
      return {
        editingTransaction: {},
        showModal: true
      }
    },
    methods: {
      saveTransaction() {
        this.showModal = false
        this.$store.dispatch("setExecuting", true)
        api.post("/accounting/transaction/" + this.currentGroup.vanityPath,
                this.editingTransaction).then(
          (results) => {
            this.$emit("transactionSaved", results.data)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 8000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
          this.showModal=true
        })
      },
      cancelTransaction() {
          this.$emit("transactionCanceled")
      },

    }
  };
</script>
<style scoped>
  .material-input {
    box-sizing: content-box;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
    outline: none;
    box-shadow: none;
  }
</style>
<style lang="scss">
  @import '~vue-datetime/dist/vue-datetime.min';
</style>
